<template>
	<v-row align="center" justify="center">
		<v-col cols="12">
			<!--v-img :src="require('../assets/logo.png')" class="ma-5" contain max-height="48" /-->

			<br />

			<user-sign-in-form></user-sign-in-form>

			<div class="text-center">
				<p class="mt-4">
					<router-link to="/forgot-password" lighten-2 class="text-center white--text">Forgot password?</router-link>
				</p>
			</div>

			<div class="text-center">
				<p class="text-center white--text">
					Create an account.
					<router-link to="/signup" class="white--text">&nbsp;Sign up</router-link>
				</p>
			</div>
		</v-col>
	</v-row>
</template>

<script>
import UserSignInForm from '@/components/user/UserSignInForm.vue';

export default {
	name: 'SignIn',
	components: {
		UserSignInForm,
	},
};
</script>
